import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { content } from "./contentCredit";
import { ezsServiceIds, idfServiceIds } from "../../../config/UserServicesList";
import { ApplicationState } from "../../../store";
import * as CreditActions from "../../../store/credit/actions";
import * as UserServiceAction from "../../../store/userService/actions";
import * as dashboardServiceActions from "../../../store/dashboardService/actions";
import { toggle } from "../../../util/common";
import { getActiveServiceCode } from "../../../util/CommonServices";
import { useAreServicesActive, useAreServicesAndFeatureActive } from "../../../util/CommonServices";
import { useBureauPermission, fetchCreditData } from "../../../util/credit";
import DedicatedResolutionSpecialistCard from "../../RightSideCard/DedicatedResolutionSpecialistCard";
import FraudAlertReminderCard from "../../RightSideCard/FraudAlertReminderCard";
import CreditScoreAllBureau from "./CreditScoreAllBureau";
import CreditScoreDaily from "./CreditScoreDaily";
import CreditScoreTracker from "./CreditScoreTracker";
import ScoreFactor from "./ScoreFactor";
import SectionHeader from "./SectionHeader";
import UpdateScore from "./UpdateScore";
import CreditExpired from "../CreditExpired";
import CreditStatus from "../CreditStatus";
import * as services from "../../../store/service";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { RECEIVE_ONETIME_CREDIT } from "../../../store/credit/types";

const CreditScore = (props: any) => {
    const { t: tLang } = useTranslation();
    const [isIdfUser, setIsIdfUser] = useState(false);
    const dispatch = useDispatch();
    const isFraudAlertRemainderActive = useAreServicesActive([idfServiceIds.fraudAlertReminder, ezsServiceIds.fraudAlertReminder]);
    const isTUUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userInfo?.isTUUser);
    const hasPurchaseCreditReport = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.hasPurchaseCreditReport);
    const hasOneTimeScore = useSelector((state: ApplicationState) => state.creditHistoryData && state.creditHistoryData.hasOneTimeScore);
    const [isBusy, setIsBusy] = useState(false);

    const bureauPermission = useBureauPermission();
    // Start Active service base UI Display Logic
    const scoreOnlyIds = [
        idfServiceIds.creditScoreMonitoring,
        idfServiceIds.threeBureauCreditScores,
        idfServiceIds.transUnionCreditScore,
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        ezsServiceIds.monthlyCreditScore,
        ezsServiceIds.tuCreditScoreTracker,
        ezsServiceIds.tuCanadaCreditScoreTracker,
        ezsServiceIds.expMonthlyCreditScoreTracker,
    ];
    const hasCreditScoreOnlyService = useAreServicesActive(scoreOnlyIds);

    const prioritizedServiceCode = useSelector((state: ApplicationState) => {
        if (state.creditHistoryData.isOneTimeOnlyScore && !hasCreditScoreOnlyService) {
            return state.creditHistoryData.oneTimeScoreServiceCode;
        } else {
            return "";
        }
    });
    const requestCreditData = () => dispatch(CreditActions.actionCreators.requestCreditData(false, bureauPermission, prioritizedServiceCode));
    const requestDailyCreditScore = () => dispatch(CreditActions.actionCreators.requestDailyCredit(false, dailyServiceCode));
    const refreshCredit = () => dispatch(CreditActions.actionCreators.refreshCredit(true, refreshCallback, reportServiceCode));
    const refreshDailyCredit = () => dispatch(CreditActions.actionCreators.refreshDailyCredit(true, refreshCallback, dailyServiceCode));

    const getUserService = (isForceCall: boolean) => dispatch(UserServiceAction.actionCreators.requestUserService(isForceCall));
    const dashboardServiceData = (isForceCall: boolean) => dispatch(dashboardServiceActions.actionCreators.getDashboardServiceData(isForceCall));

    const creditScoreTrackerIds = [idfServiceIds.creditScoreTracker];
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    let isCreditScoreTrackerActive = useAreServicesAndFeatureActive(scoreOnlyIds, ["Product.CreditScoreTracker"]);
    const idfCreditTrackerActive = useAreServicesActive(creditScoreTrackerIds);

    const creditScoreAndTrackerServiceids = [
        ezsServiceIds.monthlyCreditScore,
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        idfServiceIds.threeBureauCreditScores,
        idfServiceIds.transUnionCreditScore,
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.experianAnnualCreditReportWithScore,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.experianAnnualCreditReportForEachOf3BureausWithScore,

        idfServiceIds.creditScoreTracker,
        ezsServiceIds.tuCreditScoreTracker,
        ezsServiceIds.tuCanadaCreditScoreTracker,
        ezsServiceIds.expMonthlyCreditScoreTracker,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReport,
    ];

    const isCreditScoreOrTrackerActive = useAreServicesActive(creditScoreAndTrackerServiceids) || (hasPurchaseCreditReport && hasOneTimeScore);

    const creditScoreServiceids = [
        ezsServiceIds.monthlyCreditScore,
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        idfServiceIds.threeBureauCreditScores,
        idfServiceIds.transUnionCreditScore,
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.experianAnnualCreditReportWithScore,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.experianAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReport,
    ];

    const isCreditScoreActive = useAreServicesActive(creditScoreServiceids) || (hasPurchaseCreditReport && hasOneTimeScore);

    const canadaCreditServiceids = [
        ezsServiceIds.tuCanadaCreditScore,
        ezsServiceIds.tuCanadaCreditScoreTracker,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
        ezsServiceIds.tuCanadaCreditScoreSimulator,
        ezsServiceIds.tuCanadaQuarterlyCreditReport,
        ezsServiceIds.tuCanadaCreditMonitoring,
    ];

    const isCanadaCreditActive = useAreServicesActive(canadaCreditServiceids);

    const threeBureauIds = [
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
    ];

    const tuOneTimeCreditServiceIds = [
        ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReport,
    ];
    const dailyRefreshableCreditServiceIds = [ezsServiceIds.tuDailyCreditReportWithScore, ezsServiceIds.tuDailyCreditReport];
    const isDailyRefreshableCreditServiceActive = useAreServicesActive(dailyRefreshableCreditServiceIds);
    const hasCombinationService = useAreServicesActive(threeBureauIds) && isDailyRefreshableCreditServiceActive ? true : false;
    const dailyServiceCode = getActiveServiceCode(dailyRefreshableCreditServiceIds);
    const threeBureauServiceCode = getActiveServiceCode(threeBureauIds);

    const cadenceText =
        threeBureauServiceCode === "SVCLVL-TU-MCRDRPT-3B-SCORE"
            ? "Monthly"
            : threeBureauServiceCode === "SVCLVL-TU-QCRDRPT-3B-SCORE"
            ? "Quarterly"
            : threeBureauServiceCode === "SVCLVL-TU-ACRDRPT-3B-SCORE"
            ? "Annual"
            : "";
    let showFactorList = false;

    const viewedOneTimeScore = useSelector((state: ApplicationState) => {
        return state.oneTimeCreditData.pageViewScore;
    });
    const purchasedOneTimeScore = useSelector((state: ApplicationState) => {
        return state.oneTimeCreditData.purchasedReport;
    });
    const oneTimeCreditData = useSelector((state: ApplicationState) => {
        return state.oneTimeCreditData.oneTimeCreditData;
    });

    let creditScores = useSelector((state: ApplicationState) => {
        if (hasOneTimeScore && state?.oneTimeCreditData?.oneTimeCreditData?.scores.length > 0 && purchasedOneTimeScore && !viewedOneTimeScore) {
            if (state?.oneTimeCreditData?.oneTimeCreditData?.scores != null) {
                for (const score of state.oneTimeCreditData.oneTimeCreditData.scores) {
                    if (score["score-factor-list"]?.length > 0) {
                        showFactorList = true;
                        break;
                    }
                }
            }
            return state.oneTimeCreditData.oneTimeCreditData;
        } else {
            let scoreData = fetchCreditData(state.creditState.creditData, "score");
            if (scoreData == null) {
                scoreData = fetchCreditData(state.creditState.creditData);
            }
            if (scoreData && scoreData.scores !== null) {
                for (const score of scoreData.scores) {
                    if (score["score-factor-list"]?.length > 0) {
                        showFactorList = true;
                        break;
                    }
                }
            }
            return scoreData;
        }
    });

    const dailyCreditScores = useSelector((state: ApplicationState) => {
        if (state?.dailyCreditScoreData?.dailyCreditData?.scores != null) {
            for (const score of state.dailyCreditScoreData.dailyCreditData.scores) {
                if (score["score-factor-list"]?.length > 0) {
                    showFactorList = true;
                    break;
                }
            }
        }
        return state.dailyCreditScoreData.dailyCreditData;
    });

    if (isIdfUser) {
        isCreditScoreTrackerActive = idfCreditTrackerActive;
    } else {
        isCreditScoreTrackerActive = isCreditScoreTrackerActive;
    }

    const isLoading = useSelector((state: ApplicationState) => {
        return state.creditState.isLoading;
    });

    const isCreditHistoryLoading = useSelector((state: ApplicationState) => {
        return state.creditHistoryData.isLoading;
    });

    const isDailyScoreLoading = useSelector((state: ApplicationState) => {
        return state.dailyCreditScoreData.isLoading;
    });

    const reportServiceCode = creditScores && creditScores["score-service-code"] ? creditScores["score-service-code"] : "";
    const isOneTimeReport = tuOneTimeCreditServiceIds.includes(reportServiceCode);

    const refreshComponent = () => {
        setIsBusy(true);
        refreshCredit();
    };

    const refreshDailyComponent = () => {
        setIsBusy(true);
        refreshDailyCredit();
    };

    const refreshCallback = () => {
        // recall APIs to get latest update date
        getUserService(true);
        dashboardServiceData(true);
        setIsBusy(false);
    };

    const checkIfIdfuser = () => {
        services.isIdfUser().then((data: any) => {
            data === true ? setIsIdfUser(true) : setIsIdfUser(false);
        });

    };

    const ensureDataFetched = () => {
        const initialUrl = window.location.href;
        sessionStorage.setItem("initialUrl", initialUrl);
        checkIfIdfuser();
        if (isCreditScoreActive) {
            requestCreditData();
            if (hasCombinationService) {
                requestDailyCreditScore();
            }
        }
    };

    useEffect(ensureDataFetched, [isCreditHistoryLoading]);

    useEffect(() => {
        window.addEventListener("unload", () => {});
        // returned function will be called on component unmount
        return () => {
            if (hasOneTimeScore && purchasedOneTimeScore && !viewedOneTimeScore) {
                dispatch({ type: RECEIVE_ONETIME_CREDIT, oneTimeCreditData: oneTimeCreditData, purchasedReport: false, pageViewScore: true });
            }
            window.removeEventListener("unload", () => {});
        };
    }, []);

    const renderMessageScreen = () => {
        if (creditScores && (creditScores.IsIDFUser || isTUUser) && (creditScores["tu-status"] === "tu-thin-error" || creditScores["tu-status"] === "tu-down")) {
            return <CreditStatus status={creditScores["tu-status"]} />;
        }  else if (creditScores && (creditScores.IsIDFUser || isTUUser) && creditScores.IsScoreExpired) {
            return <CreditExpired />;
        } else {
            return renderScoreScreen();
        }
    };

    const renderScoreTracker = () => {
        if (isCreditScoreActive && isCreditScoreTrackerActive) {
            if (!isLoading) {
                return <CreditScoreTracker isIDFUser={isIdfUser} source={"credit"} showWYNTK={!isCreditScoreActive && !isCanadaCreditActive} />;
            }
        } else if (isCreditScoreTrackerActive) {
            return <CreditScoreTracker isIDFUser={isIdfUser} source={"credit"} showWYNTK={!isCreditScoreActive && !isCanadaCreditActive} />;
        }
    };

    const renderScoreScreen = () => {
        return (
            <React.Fragment>
                <div className="box margin-bottom-xs" style={{ paddingTop: 0 }}>
                    <h3 className="content-title">{hasCombinationService ? "Three Bureau " + cadenceText + " Credit Score" : ""}</h3>
                        <UpdateScore
                        isDashboardView={false}
                        updateComponent={refreshComponent}
                        updateDate={creditScores && creditScores.IsIDFUser ? creditScores["update-date"] : creditScores["score-update-date"]}
                        nextAvailableUpdate={creditScores && creditScores.IsIDFUser ? creditScores["next-update-date"] : creditScores["next-score-update-date"]}
                        isIDFUser={creditScores && creditScores.IsIDFUser}
                        isTUUser={isTUUser}
                        combinationRefresh={false}
                        isOneTimeReport={isOneTimeReport}
                        tuStatus = {creditScores["tu-status"]}
                        />
                    <CreditScoreAllBureau />

                    {showFactorList ? (
                        <React.Fragment>
                            <div className="space-divider margin-top-l"></div>
                            <button
                                aria-expanded="false"
                                className="btn-default btn-toggle btn-no-padding"
                                id="btn_more_score_factors_3b"
                                onClick={() => toggle("mydiv_3b", "btn_more_score_factors_3b")}
                            >
                                <span className="btn-toggle-status sr-only">Show</span>
                                <span className="btn-text">{tLang("credit.creditScore.creditScoreWidget.label.moreScoreFactors")}</span>
                            </button>

                            <div className="card" id="mydiv_3b" style={{ display: "none" }}>
                                <ScoreFactor factors={creditScores.scores} />
                            </div>
                        </React.Fragment>
                    ) : null}
                </div>
                {hasCombinationService && (
                    <div className="box padding-top-xs">
                        <h3 className="content-title">{content.dailyCreditScoreHeader}</h3>
                        <UpdateScore
                            isDashboardView={false}
                            updateComponent={refreshDailyComponent}
                            updateDate={dailyCreditScores.IsIDFUser ? dailyCreditScores["update-date"] : dailyCreditScores["score-update-date"]}
                            nextAvailableUpdate={dailyCreditScores.IsIDFUser ? dailyCreditScores["next-update-date"] : dailyCreditScores["next-score-update-date"]}
                            serviceCode={creditScores["score-service-code"]}
                            isIDFUser={dailyCreditScores.IsIDFUser}
                            isTUUser={isTUUser}
                            combinationRefresh={true}
                            isOneTimeReport={isOneTimeReport}
                            tuStatus={dailyCreditScores["tu-status"]}
                        />
                        <CreditScoreDaily />

                        {showFactorList ? (
                            <React.Fragment>
                                <div className="space-divider margin-top-l"></div>
                                <button
                                    aria-expanded="false"
                                    className="btn-default btn-toggle btn-no-padding"
                                    id="btn_more_score_factors_1b"
                                    onClick={() => toggle("mydiv_1b", "btn_more_score_factors_1b")}
                                >
                                    <span className="btn-toggle-status sr-only">Show</span>
                                    <span className="btn-text">{tLang("credit.creditScore.creditScoreWidget.label.moreScoreFactors")}</span>
                                </button>

                                <div className="card" id="mydiv_1b" style={{ display: "none" }}>
                                    <ScoreFactor factors={dailyCreditScores.scores} />
                                </div>
                            </React.Fragment>
                        ) : null}
                    </div>
                )}
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            {isCreditScoreOrTrackerActive === true ? (
                <>
                    <div className={`${isBusy && "loading"}`}>
                        <div className="row" id="content">
                            <div className="col-xs col-no-gutter">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-8">
                                        {isCreditScoreActive && (
                                            <div className="box offset-padding">
                                                {(!hasCombinationService && creditScores != null) ||
                                                (hasCombinationService && creditScores != null && dailyCreditScores != null) ? (
                                                    <div>
                                                        <div className="box-header">
                                                            <SectionHeader
                                                                headerText={tLang("credit.creditScore.creditScoreWidget.title")}
                                                                iconName="la-tachometer-alt"
                                                            />

                                                            {creditScores["tu-status"] !== "tu-thin-error" &&
                                                                creditScores.IsScoreExpired === false && (
                                                                    <div className="box-description">
                                                                        <p> {tLang(content.creditScoreHeader)}</p>
                                                                    </div>
                                                                )}
                                                            {creditScores["tu-status"] !== "tu-thin-error" &&
                                                                !isCanadaCreditActive &&
                                                                creditScores.IsScoreExpired === false && (
                                                                    <>
                                                                        <div className="box-description">
                                                                            <p dangerouslySetInnerHTML={{ __html: tLang(content.whatYouNeedToKnowDescription) }}></p>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            <div className="box-actions"></div>
                                                        </div>
                                                        <div className="box-content credit-score-page">{renderMessageScreen()}</div>
                                                    </div>
                                                ) : (
                                                    <React.Fragment>
                                                        {(hasCombinationService && (isLoading || isDailyScoreLoading)) || (!hasCombinationService && isLoading) ? (
                                                            <div className="box loading"></div>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </React.Fragment>
                                                )}
                                            </div>
                                        )}
                                        <>{renderScoreTracker()} </>
                                    </div>
                                    <div className="col-xs-12 col-sm-4">
                                        {isFraudAlertRemainderActive && <FraudAlertReminderCard />}
                                        <DedicatedResolutionSpecialistCard />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="row" id="content">
                        <div className="col-xs-12">
                            <div className="box">
                                <div className="text-align-center">
                                    <div className="color-alert msg-small margin-top-xs">
                                        <RenderIcons iconName="info-circle" /> This feature is not included in your subscription.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </React.Fragment>
    );
};

export default CreditScore;
